import { api } from "./api";

const KEY = "gk_active_child";

export const getActiveChild = () => {
  try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; }
};
export const setActiveChild = (c) => localStorage.setItem(KEY, JSON.stringify(c));
export const clearActiveChild = () => localStorage.removeItem(KEY);

// Fire-and-forget sync helpers (only call when a child is active + parent signed in)
export const syncFeeling = (childId, feeling) =>
  api.post(`/children/${childId}/feelings`, { feeling }).catch(() => {});
export const syncActivity = (childId, activityId, points, badge) =>
  api.post(`/children/${childId}/activity`, { activityId, points, badge }).catch(() => {});
export const syncColoring = (childId, pageId, meta = {}) =>
  api.post(`/children/${childId}/coloring`, { pageId, ...meta }).catch(() => {});
export const recordStoryRead = (childId, payload) =>
  api.post(`/children/${childId}/story-read`, payload).catch(() => {});
export const logReading = (childId, payload) =>
  api.post(`/children/${childId}/reading-log`, payload).then((r) => r.data).catch(() => null);
export const getReadingInsights = (childId) =>
  api.get(`/children/${childId}/reading-insights`).then((r) => r.data).catch(() => null);
export const syncGame = (childId, level, starsEarned, badge, crown) =>
  api.post(`/children/${childId}/game`, { level, starsEarned, badge, crown }).then((r) => r.data).catch(() => null);
export const syncWordSearch = (childId, payload) =>
  api.post(`/children/${childId}/wordsearch`, payload).then((r) => r.data).catch(() => null);
export const syncPuzzle = (childId, slug) =>
  api.post(`/puzzles/${slug}/complete/${childId}`).then((r) => r.data).catch(() => null);
export const syncSelChallenge = (childId, payload) =>
  api.post(`/children/${childId}/sel-challenge`, payload).then((r) => r.data).catch(() => null);
export const syncKindnessBloom = (childId, payload) =>
  api.post(`/children/${childId}/kindness-bloom`, payload).then((r) => r.data).catch(() => null);
export const syncFeelingsMatch = (childId, payload) =>
  api.post(`/children/${childId}/feelings-match`, payload).then((r) => r.data).catch(() => null);

// Coloring artwork (private per-family). Returns response data or null on failure.
export const saveArtwork = (childId, payload) =>
  api.post(`/children/${childId}/artworks`, payload).then((r) => r.data).catch(() => null);
export const listArtworks = (childId) =>
  api.get(`/children/${childId}/artworks`).then((r) => r.data).catch(() => []);
export const favoriteArtwork = (childId, artworkId, favorite) =>
  api.patch(`/children/${childId}/artworks/${artworkId}`, { favorite }).then((r) => r.data).catch(() => null);
export const deleteArtwork = (childId, artworkId) =>
  api.delete(`/children/${childId}/artworks/${artworkId}`).then((r) => r.data).catch(() => null);
export const unlockCreative = (childId) =>
  api.post(`/children/${childId}/creative-unlock`).then((r) => r.data).catch(() => null);
export const saveRecipe = (childId, payload) =>
  api.post(`/children/${childId}/color-recipe`, payload).then((r) => r.data).catch(() => null);

// Gradient Recipe Book — saved "Surprise Me" blends (private per child).
export const listGradientRecipes = (childId) =>
  api.get(`/children/${childId}/gradient-recipes`).then((r) => r.data).catch(() => null);
export const saveGradientRecipe = (childId, payload) =>
  api.post(`/children/${childId}/gradient-recipes`, payload).then((r) => r.data).catch(() => null);
export const updateGradientRecipe = (childId, recipeId, payload) =>
  api.patch(`/children/${childId}/gradient-recipes/${recipeId}`, payload).then((r) => r.data).catch(() => null);
export const deleteGradientRecipe = (childId, recipeId) =>
  api.delete(`/children/${childId}/gradient-recipes/${recipeId}`).then((r) => r.data).catch(() => null);

// Community Showcase — child request (parent must approve before anything is public).
export const requestShowcase = (childId, payload) =>
  api.post(`/children/${childId}/showcase/request`, payload).then((r) => r.data).catch((e) => { throw e; });
